import { FaFacebook } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";
import { FaYoutube } from "react-icons/fa";
import { useSearchParams } from 'react-router-dom';
import FacebookShareButton from './FacebookShareButton';

export function MeriaInner({ data }) {
  const [searchParams] = useSearchParams();
  const currentUrl = window.location.href;

  return (
    <>
    <div className='meria-inner'>
        <div className="meria-image">
            <img src={data?.image} alt="Meria" />
        </div>
        <div className="meria-name">
            <h4>{data?.full_name}</h4>
            <p>{data?.position}</p>

      
        <div className="meria-details">
            <h5>საკონტაქტო ინფორმაცია</h5>
            <p><strong>ელ.ფოსტა:</strong> <a href={`mailto:${data?.email}`}>{data?.email}</a></p>
            <p><strong>ტელეფონი:</strong> <a href={`tel:${data?.mobile}`}>{data?.mobile}</a></p>
            {/* <p><strong>მისამართი:</strong> <span>{data.address}</span></p>
            <p><strong>ვებსაიტი:</strong> <a href={data.website}>{data.website}</a></p> */}
        </div>
         <div className="meria-socials">
            <h5>სოციალური ქსელები</h5>
                <a href={data?.facebook} target="_blank" rel="noopener noreferrer"><FaFacebook /></a>
                <a href={data?.instagram} target="_blank" rel="noopener noreferrer"><FaInstagram /></a>
                <a href={data?.youtube} target="_blank" rel="noopener noreferrer"><FaYoutube /></a>
            </div>
        </div>
    </div>
    <div className="meria-dec">
        <p dangerouslySetInnerHTML={{ __html: data?.description }}></p>
    </div>
    <FacebookShareButton productUrl={currentUrl} title={data?.full_name} description={data?.description} image={data?.image} />
    </>
  )
}
